const initState = {
    dataUsuarioParaInmueble:null,
    dataUsuarioRegistrado:false,
    dataUsuarioRegistradomensaje:'',
    conexion: false,
    error: false,
    envioAgregar: false,
};

export default initState;